import { useEffect } from 'react';

import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';

const NOTIFICATION_KEY = 'route-access-denied';

interface AccessDeniedRedirectProps {
  hasOrgAccess: boolean;
}

const AccessDeniedRedirect = ({ hasOrgAccess }: AccessDeniedRedirectProps) => {
  const intl = useIntl();

  useEffect(() => {
    notification.warning({
      key: NOTIFICATION_KEY,
      message: intl.formatMessage({ id: 'authRoute.accessDenied.title' }),
      description: intl.formatMessage({
        id: hasOrgAccess
          ? 'authRoute.accessDenied.permissions'
          : 'authRoute.accessDenied.organization',
      }),
    });
  }, [hasOrgAccess, intl]);

  return <Redirect to="/" />;
};

export default AccessDeniedRedirect;
